 
import styles from './AchievedCorrection.module.css';

import AchievedCorrectionMetrics from './AchievedCorrectionMetrics';
import AlignmentValidation from './AlignmentValidation';
import { CaseReport } from '../../models/CaseTypes';
import SpineViewer from './SpineViewer';
import { useAchievedCorrection } from './useAchievedCorrection';

/**
 * Component to display the Achieved Correction data
 * Shows comparison between pre-op and other measurement points (intra-op, post-op)
 */
const AchievedCorrection = ({ caseReport } : {caseReport:CaseReport}):
  React.JSX.Element => {

  const {
    loading,
    error,
    metricSessions,
    primarySession,
    comparisonSession,
    primaryMeshSignedUrl,
    comparisonMeshSignedUrl,
    selectedVertebraChecks,
    selectedVertebraeNames,
    selectedPlaneNames,
    preOpData,
    comparisonData,
    validationSignedUrl,
    handlePrimaryChange,
    handleComparisonChange,
    handleVertebraCheckboxChange,
  } = useAchievedCorrection(caseReport);

  if (loading && (!preOpData.length || !comparisonData.length)) {
    return <div className="loading">Loading alignment data...</div>;
  }

  if (error || !metricSessions.length) {
    return (
      <div className="alignment-measurements">
        <div className="warning-message">
          Alignment data is not available for this case.
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 lg:gap-5">
      <div className={styles['alignment-measurements']}>

        <div className={styles['header-container']}>
          Alignment Measurements
        </div>

        <div className={styles['three-d-views']}>
          <SpineViewer
            id="primary-select"
            metricSessions={metricSessions}
            onSessionChange={handlePrimaryChange}
            session={primarySession}
            selectedPlaneNames={selectedPlaneNames}
            selectedVertebraeNames={selectedVertebraeNames}
            signedUrl={primaryMeshSignedUrl}
          />

          <SpineViewer
            id="comparison-select"
            metricSessions={metricSessions}
            onSessionChange={handleComparisonChange}
            session={comparisonSession}
            selectedPlaneNames={selectedPlaneNames}
            selectedVertebraeNames={selectedVertebraeNames}
            signedUrl={comparisonMeshSignedUrl}
          />
        </div>

        <AchievedCorrectionMetrics
          comparisonData={comparisonData}
          comparisonSession={comparisonSession}
          primarySession={primarySession}
          selectedVertebrae={selectedVertebraChecks}
          onVertebraeCheckboxChange={handleVertebraCheckboxChange}
        />

      </div>

      { validationSignedUrl && (
        <AlignmentValidation validationSignedUrl={validationSignedUrl} />
      )}
    </div>
  );
};

export default AchievedCorrection;
